import { render, staticRenderFns } from "./MyRentalRequests.vue?vue&type=template&id=16672276&"
import script from "./MyRentalRequests.vue?vue&type=script&lang=ts&"
export * from "./MyRentalRequests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports